// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"213f704c","359":"d4cef183","511":"23b5b818","674":"b9d98335","767":"2318e836"}[chunkId] + ".chunk.js";
};